import { render, staticRenderFns } from "./success_case_add.vue?vue&type=template&id=9f47fbc0"
import script from "./success_case_add.vue?vue&type=script&lang=js"
export * from "./success_case_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports